import { render } from "./SetsMarriageDialog.vue?vue&type=template&id=4da15ac0"
import script from "./SetsMarriageDialog.vue?vue&type=script&lang=js"
export * from "./SetsMarriageDialog.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__